<template>
  <metainfo></metainfo>
  <div class="container-xl">
    <div class="page-header d-print-none">
      <div class="row g-2 align-items-center">
        <div class="col-sm">
          <h2 class="page-title">
            <WishHeader :data="{
              'title_page': params.h1,
              'count_items': countItems,
              'page': getPageName()
            }"/>
          </h2>
        </div>
        <div class="col-auto">
          <Actions />
        </div>
      </div>
    </div>
  </div>
  <div class="page-body">
    <div class="container-xl">
      <div class="mb-2">
        <WishesFilter
            @onFilter="onFilter"
            :enable="filter.enable"
            :params="filter.params"
        />
      </div>
      <div ref="scrollComponent">
        <WishesList
            :query="query"
            :clear-result="clearResult"
            @onRender="onRender
        "/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, onUnmounted, watch, defineOptions} from "vue"
import { useRoute } from "vue-router"
import { useMeta } from "vue-meta"
import WishHeader from "@/modules/wishlist/components/wish_header1/Index"
import Actions from "@/modules/wishlist/components/actions/Index"
import WishesFilter from "@/modules/wishlist/components/filter/Index"
import WishesList from "@/modules/wishlist/components/list/Index"
import Helper from "@/services/Helper"

defineOptions({
  name: "WishlistPageWishes"
})

const props = defineProps({
  object: {
    type: Object,
    required: true,
  },
  params: {
    type: Object,
    required: true,
  },
})

useMeta({ title: props.params.title })

const route = useRoute()
const filterParams = props.object.filterParams()
const filter = ref(getFilter())
const query = ref({})
const clearResult = ref(false)
const offset = ref(0)
const eofResult = ref(false)
const countItems = ref(0)
const scrollComponent = ref(null)
const isLoading = ref(false)

watch(() => route.query, () => {
  filter.value = getFilter()
})

function getFilter() {
  return {
    params: {
      search: filterParams.params.search ?? "",
      date: filterParams.params.date ?? [],
      users: filterParams.params.users ?? [],
      categories: filterParams.params.categories ?? [],
      is_moderate: filterParams.params.is_moderate ?? null,
      themes: filterParams.params.themes ?? [],
      wishlists: filterParams.params.wishlists ?? [],
    },
    enable: filterParams.enable ?? true,
  }
}

function getPageName() {
  return props.params.page
}

function onRender(payload) {
  eofResult.value = payload["oef_items"] === true

  if (payload["count_items"] > 0) {
    countItems.value = payload["count_items"]
  }

  clearResult.value = false
  isLoading.value = false
}

function onFilter(q) {
  clearResult.value = true
  offset.value = 0
  eofResult.value = false
  countItems.value = 0

  if (props.params.page === "wishes_moderate") {
    q = Helper.mergeObject(q, {
      "is_moderate": false,
    })
  }

  q = Helper.mergeObject(q, {
    "limit": 18,
    "offset": offset.value,
    "page": props.params.page,
    "delst": false,
  })

  query.value = q
}

function onLoadMore(currentOffset) {
  if (Helper.isEmptyObject(query.value)) {
    return false
  }

  const q = Helper.clone(query.value)

  query.value = Helper.mergeObject(q, {
    "offset": currentOffset,
  })
}

const scroll = () => {
  isLoading.value = true
  offset.value += 18
  onLoadMore(offset.value)
}

const handleScroll = () => {
  if (eofResult.value) return

  const element = scrollComponent.value

  if (!isLoading.value && element && element.getBoundingClientRect().bottom < window.innerHeight) {
    scroll()
  }
}

onMounted(() => {
  window.addEventListener("scroll", handleScroll)
})

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll)
})
</script>
